import {PackageParam} from "../entities/PackageTemplate";
import {AxiosProgressEvent} from "axios";
import {Response} from "../entities/Response";
import {PackageRecord} from "../entities/PackageRecord";
import apiClient, {createApiClient} from "./http";
import Page, {PageList} from "../entities/Page";
import {DeployRecord} from "../entities/DeployRecord";
import {DeployPackageProps} from "./DeployService";

export interface BuildPackageProps {
    appKey: string;
    env: string;
    param?: PackageParam;
    packageName?: string;
}

export default class PackageService {

    static async uploadPackage(
        request: BuildPackageProps,
        file: File,
        onProgress: (progressEvent: AxiosProgressEvent) => void
    ): Promise<Response<PackageRecord>> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("request", JSON.stringify(request));
        const client = createApiClient({ timeoutInMills: 600000 });
        return await client.post("/service/package/upload", formData, {
            onUploadProgress: onProgress
        });
    }

    static async buildPackage(request: BuildPackageProps) : Promise<Response<PackageRecord>> {
        return await apiClient.post("/service/package/build", request);
    }

    static async getPackageRecord(request: { id: number }) : Promise<Response<PackageRecord>> {
        return await apiClient.post("/service/package/record/get", request);
    }

    static async deletePackageRecord(request: { id: number }) : Promise<Response<any>> {
        return await apiClient.post("/service/package/record/package/delete", request);
    }

    static async listPackages(request: { appKey: string, env: string, page: Page, keyword?: string }) : Promise<Response<PageList<PackageRecord>>> {
        return await apiClient.post("/service/package/list", request);
    }

    static async listPackageRecords(request: { page: Page, appKey: string, env: string }) : Promise<Response<PageList<PackageRecord>>> {
        return await apiClient.post("/service/package/record/list", request);
    }


}
